import { useQuery } from "@tanstack/react-query";
import { fetchReviews } from "../services/reviewService";

export const useReviews = (page = 1) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["reviews", page],
    queryFn: () => fetchReviews(page),
    select: (response) => {
      return {
        reviews: response.message?.data || [],
        pagination: {
          current_page: response.message?.current_page,
          total: response.message?.total,
          per_page: response.message?.per_page,
          last_page: response.message?.last_page,
        },
      };
    },
  });

  return {
    reviews: data?.reviews || [],
    loading: isLoading,
    error: error?.message || null,
    pagination: data?.pagination || null,
  };
};
